<template>
    <div>
    <div v-if="api.editUnsavedCount || api.editPendingCount || api.arrivalCancelledMessage" class="timesheet-arrival-cancelled" :role="api.editUnsavedCount ? 'alert' : 'status'" aria-live="polite">
        <span v-if="api.editUnsavedCount">Не записано в табель: {{ api.editUnsavedCount }} отметок. При обновлении или закрытии страницы несохранённый ввод будет потерян.</span>
        <span v-else-if="api.editPendingCount">Сохраняется: {{ api.editPendingCount }}</span>
        <span v-else>{{ api.arrivalCancelledMessage }}</span>
        <button v-if="api.editProblems.length" type="button" class="btn btn-sm btn-outline-danger" :disabled="api.editResolutionPending || api.editPendingCount > 0"
            @click="api.resolveEditProblem(api.editProblems[0].key)">Проверить и повторить</button>
    </div>
    <div v-if="api.editErrorCount" class="alert alert-warning timesheet-edit-errors" role="alert">
        <div v-for="problem in api.editProblems" :key="problem.key">
            <strong>{{ problem.label }}</strong> — {{ problem.message }}
            <span class="timesheet-edit-errors__value">Ваш ввод: <code>{{ problem.value || 'пусто' }}</code></span>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="api.showEmployeeSearchProblem(problem.key)">Показать строку</button>
            <button type="button" class="btn btn-sm btn-outline-danger" :disabled="api.editResolutionPending" @click="api.resolveEditProblem(problem.key)">Проверить и повторить</button>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'TimesheetEditProblems',
    props: {api: {type: Object, required: true}}
};
</script>

<style scoped>
.timesheet-arrival-cancelled {
    position: fixed;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1040;
    width: max-content;
    max-width: calc(100vw - 24px);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid #adc7dc;
    border-radius: 6px;
    background: #f2f7fb;
    color: #354b60;
    box-shadow: 0 2px 10px #0002;
}
</style>
